@let vm =
    {
        isFlightRequested: isFlightRequested$ | async,
    };

<div id="flightTab" class="tab flex flex-col gap-medpace">
    @if (!isFlightAvailable()) {
        <medpace-alert [appearance]="'highlight'" [content]="nonAvailableMessage" />
    }
    @if (isFlightAvailable() || vm.isFlightRequested) {
        <medpace-needs-travel-radio-group
            [label]="'Will the patient need air travel?'"
            [isDisabled]="isLimitedService()"
            [isUpdate]="isUpdate()"
            [formCtrl]="formGroup().controls.needsTravel"
        />
        @if (formGroup().controls.needsTravel.value) {
            <div>
                <mds-divider />
                <mds-expansion-panel
                    class="expansion-panel-request !border-y-0"
                    [panelTitle]="'Flight preferences'"
                    [description]="'(from Patient Profile)'"
                >
                    <medpace-flight-preferences
                        [formGroup]="formGroup().controls.travel.controls.preferences"
                        [mode]="'view'"
                    />
                </mds-expansion-panel>
                <mds-divider />
            </div>
            <medpace-flight-request-details
                [mode]="isLimitedService() ? 'view' : mode()"
                [formGroup]="formGroup().controls.travel.controls.requestDetails"
            />
        }
    }
</div>
